export default "__VITE_ASSET__UFL_K4xZ__"